var isRegExp = require('../internals/is-regexp');
module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  }
  return it;
};